import {useLocationParams} from '../../../components/Router/RouterProvider';

export const useView = () => {
    const params = useLocationParams();
    const {view} = params || {};
    return view || 'room-list';
};